document.documentElement.classList.remove('no-js');
const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
async function changeLine(line,quantity){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});location.reload()}
async function clearCart(){await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}});location.reload()}
document.addEventListener('click',e=>{
 const q=e.target.closest('[data-qty-change]'); if(q){const row=q.closest('[data-line]'), n=Number(row.querySelector('[data-qty-value]').textContent); changeLine(Number(row.dataset.line),Math.max(0,n+Number(q.dataset.qtyChange)))}
 const r=e.target.closest('[data-remove]'); if(r) changeLine(Number(r.closest('[data-line]').dataset.line),0);
 if(e.target.closest('[data-clear-cart]')) clearCart();
 const pq=e.target.closest('[data-product-qty]'); if(pq){const i=pq.closest('.product-qty').querySelector('input'); i.value=Math.max(1,Number(i.value)+Number(pq.dataset.productQty))}
});
$$('[data-product-form]').forEach(form=>{
 const select=form.querySelector('[data-variant-select]'), price=document.querySelector('[data-product-price]'), add=form.querySelector('[data-add-to-cart]');
 const radios=$$('input[data-option]',form);
 function sync(){if(!select||!radios.length)return;const vals=radios.filter(i=>i.checked).map(i=>i.value);const opt=[...select.options].find(o=>o.dataset.options.split('||').every((v,i)=>v===vals[i]));if(!opt)return;select.value=opt.value;price.textContent=opt.dataset.price;const ok=opt.dataset.available==='true';add.disabled=!ok;add.textContent=ok?(add.dataset.preorder==='true'?'PRE-ORDER NOW':'ADD TO CART'):'SOLD OUT'}
 radios.forEach(i=>i.addEventListener('change',sync));
 form.addEventListener('submit',async e=>{e.preventDefault();add.disabled=true;const old=add.textContent;add.textContent='ADDING…';try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});if(!res.ok)throw new Error();window.location.href='/cart'}catch(err){add.textContent='TRY AGAIN';setTimeout(()=>{add.textContent=old;add.disabled=false},1200)}})
});

// Product image carousel
$$('[data-product-gallery]').forEach(gallery=>{
  const track=$('[data-gallery-track]',gallery), slides=$$('[data-gallery-slide]',gallery), thumbs=$$('[data-gallery-thumb]',gallery), current=$('[data-gallery-current]',gallery);
  if(!track || slides.length < 2) return;
  let index=0, startX=0;
  const go=(next)=>{index=(next+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;thumbs.forEach((t,i)=>t.classList.toggle('is-active',i===index));if(current)current.textContent=index+1;const active=thumbs[index];if(active)active.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})};
  $('[data-gallery-prev]',gallery)?.addEventListener('click',()=>go(index-1));
  $('[data-gallery-next]',gallery)?.addEventListener('click',()=>go(index+1));
  thumbs.forEach(t=>t.addEventListener('click',()=>go(Number(t.dataset.galleryThumb))));
  track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX},{passive:true});
  track.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)go(index+(dx<0?1:-1))},{passive:true});
});


// OTM first successful password-access intro
(function(){
  const intro=document.querySelector('[data-otm-motion-intro]');
  if(!intro)return;
  let pending=false,seen=false;
  try{
    pending=sessionStorage.getItem('otmPasswordEntryPending')==='1';
    seen=localStorage.getItem('otmMotionIntroSeen')==='1';
  }catch(e){}
  if(!pending||seen)return;
  intro.classList.add('is-active');
  document.body.classList.add('otm-intro-lock');
  try{
    sessionStorage.removeItem('otmPasswordEntryPending');
    localStorage.setItem('otmMotionIntroSeen','1');
  }catch(e){}
  const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hold=reduced?850:2450;
  window.setTimeout(()=>{
    intro.classList.add('is-leaving');
    window.setTimeout(()=>{
      intro.remove();
      document.body.classList.remove('otm-intro-lock');
    },reduced?100:650);
  },hold);
})();
